export const validateUsername = (input: string) => {
  if (input.length < 4 || input.length > 15)
    return '아이디는 5자 이상 15자 이하로 입력해주세요';
  if (!/(?=.*[A-Za-z])[A-Za-z\d]{5,15}/.test(input))
    return '알파벳 혹은 숫자만 입력할 수 있습니다';
  return true;
};

export const validateName = (input: string) => {
  if (input.length < 2 || input.length > 20)
    return '이름은 2자 이상 20자 이내로 입력해주세요';
  if (!/^[가-힣]*$/.test(input) && !/^[A-Za-z][A-Za-z\_]*[A-Za-z]$/.test(input))
    return '한글 혹은 영어+공백만 입력할 수 있습니다';
  return true;
};

export const validatePassword = (input: string) => {
  if (input.length < 8 || input.length > 20)
    return '비밀번호는 8자 이상 20자 이하로 입력해주세요';
  return true;
};

export const validatePhone = (input: string) => {
  const PHONE_PATTERN = /01[\d]{8,9}/;
  if (!PHONE_PATTERN.test(input)) return '정확한 휴대폰 번호를 입력해주세요';
  return true;
};

export const validateBank = (input: string) => {
  if (input.length < 2 || input.length > 15)
    return '은행명은 2자 이상 15자 이내로 입력해주세요';
  if (!/[가-힣]$/g.test(input)) return '한글만 입력할 수 있습니다';
  return true;
};

export const validateAccount = (input: string) => {
  if (input.length < 8 || input.length > 20)
    return '계좌번호는 8자 이상 20자 이내로 입력해주세요';
  if (!/[0-9]$/g.test(input)) return '숫자만 입력할 수 있습니다';
  return true;
};

export const validatePharmacyName = (input: string) => {
  if (input.length < 2 || input.length > 15)
    return '약국명은 2자이상 15자 이내로 입력해주세요';
  return true;
};

export const validateDetailAddress = (input: string) => {
  if (input.length < 2 || input.length > 20)
    return '상세주소는 2자 이상 20자 이내로 입력해주세요';
  return true;
};

export const validateTel = (input: string) => {
  if (!/^[\d]{8,12}$/.test(input))
    return '전화번호는 숫자만, 8자 이상 12자 이내로 입력해주세요';
  return true;
};

export const validateEmail = (input: string) => {
  if (!/^\S+@\S+\.\S+$/.test(input)) return '정확한 이메일 주소를 입력해주세요';
  return true;
};

export const validateBusinessNumber = (input: string) => {
  if (!/[0-9]$/g.test(input)) return '숫자만 입력할 수 있습니다';
  return true;
};

export const hasGraphqlError = (
  response?: any | null
): response is BffResponseError | undefined => {
  if (typeof response === 'undefined' || response === null) return true;
  return response?.errors !== undefined;
};

export const isEmpty = (
  target: string | [] | Record<string, any> | undefined | null
) => {
  if (target === undefined || target === null) return true;
  if (typeof target === 'object') return Object.keys(target).length === 0;
  return Boolean(target) === false;
};

export const validateMinNumber = (
  input: number,
  minNumber: number
) => {
  return input >= minNumber;
};

export const validateNumberUnit = (
  input: number,
  unit: number
) => {
  return input % unit === 0;
}